export default [
    
    {
    date: "11/11",
    description: "Abertura / O meu futuro \"uma nova abordagem\"",
    place: "Auditório I",
    speaker: "Dra. Rosa Maria de Castro Fernandes",
    time: "19:00",
}, {
    date: "12/11",
    description: "Desafios para a engenharia de cristais na indústria farmacêutica",
    place: "Auditório I",
    speaker: "Dr. Alejandro Pedro Ayala",
    time: "09:00",
}, {
    date: "12/11",
    description: "Novas tecnologias e novas profissões: perspectivas da Física Médica no Brasil",
    place: "Auditório I",
    speaker: "Dr. Fabrício Augusto de Lima",
    time: "10:45",
}, {
    date: "12/11",
    description: "Novas tecnologias e novas profissões: perspectivas da Física Médica no Brasil",
    place: "Auditório I",
    speaker: "Dr. Fabrício Augusto de Lima",
    time: "19:00",
}, {
    date: "12/11",
    description: "\"STEAM BY ME\": A experiência de uma comunidade de prática de ensino de ciências enquanto estratégia formativa de professores de ciências dentro de uma abordagem STEAM",
    place: "Auditório II",
    speaker: "Prof. Dr. Jancarlos Menezes Lapa",
    time: "19:00",
}, {
    date: "12/11",
    description: "Desafios para a engenharia de cristais na indústria farmacêutica",
    place: "Auditório I",
    speaker: "Prof. Dr. Alejandro Pedro Ayala",
    time: "20:30-",
}, {
    date: "12/11",
    description: "Tecnologias na Educação",
    place: "Auditório II",
    speaker: "Profa. Dra. Adda Daniela Lima Figueiredo Echalar",
    time: "20:30",
}, {
    date: "13/11",
    description: "Mercado Tecnológico, adaptação e transformação dos negócios",
    place: "Auditório II",
    speaker: "Luciano Lacerda",
    time: "09:00",
}, {
    date: "13/11",
    description: "XIX Jornada Goiana de Engenharia de Software",
    place: "Auditório I",
    speaker: "Ver programação abaixo",
    time: "09 às 18",
}, {
    date: "13/11",
    description: "Predicting Brazilian court decisions",
    place: "Auditório I",
    speaker: "Prof. Dr. André Lage Freitas",
    time: "19:00",
}, {
    date: "13/11",
    description: "Tecnologia para aprender matemática",
    place: "Aud II",
    speaker: "Prof. Dr. Sergio Carrazedo Dantas",
    time: "19:00",
}, {
    date: "13/11",
    description: "Educação: a Tecnopedagogia o Currículo e a Indústria",
    place: "Auditório II",
    speaker: "Profa. MSC Clélia Brandão Alvarenga Craveiro",
    time: "20:30 ",
}, {
    date: "14/11",
    description: "New Horizons in MR Imaging - Opportunity and Challenges of Sparse Samplimg and Constrained Reconstruction",
    place: "Auditório I",
    speaker: "Prof. Dr. Richard Frayne",
    time: "09:00",
}, {
    date: "14/11",
    description: "Aprendizagem de máquina e suas aplicações na Medicina",
    place: "Auditório I",
    speaker: "Profa. Dra. Letícia Rittner",
    time: "10:45",
}, {
    date: "14/11",
    description: "Aprendizagem de máquina e suas aplicações na Medicina",
    place: "Auditório I",
    speaker: "Profa. Dra. Letícia Rittner",
    time: "19:00",
}, {
    date: "14/11",
    description: "Você trabalha ou só dá aula? Um olhar sobre as pesquisas acerca da formação profissional de professores de química",
    place: "Auditório II",
    speaker: "Prof. Dr. Amadeu Moura Bego",
    time: "19:00",
}, {
    date: "14/11",
    description: "New Horizons in MR Imaging - Opportunity and Challenges of Sparse Samplimg and Constrained Reconstruction",
    place: "Auditório I",
    speaker: "Prof. Dr. Richard Frayne",
    time: "20:30",
}, {
    date: "14/11",
    description: "Estágio Supervisionado, Física, Campo Escolar ... Um contexto técnico cientifico à luz de uma analise BigData",
    place: "Auditório II",
    speaker: "Prof. Dr. Luiz Gonzaga Roversi",
    time: "20:30",
}, ]